/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Nov-09
 *
 * bestgob-client - procedure.form.validator.js
 **/

const procedureFormValidator = {
    input: {
        required: (required, readOnly) => {
            return v => (!required || !!v || !!readOnly) || `Este campo es requerido.`
        },
        min_max_length: (min_value, max_value) => {
            return v => (!!v && (!min_value || v.length >= min_value) && (!max_value || v.length <= max_value)) || `Debe tener entre ${min_value ? min_value : 0} y ${max_value? max_value : 'n'} caracteres`
        },
        exact_length: (exact_value) => {
            return v => !!v && v.length == exact_value || `Debe tener ${exact_value} caracteres`
        },
        rfc: rfc => !!rfc && /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/.test(rfc.toUpperCase()) || 'Ingresa un RFC válido.',
        curp: curp => !!curp && /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HMX](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/.test(curp.toUpperCase()) || 'Ingresa una CURP válida ',
        numeric: v => !!/^\d+$/.test(v) || `Este campo solo acepta números`
    },

    checkbox_group: {
        required: (required, readOnly) => {
            return v => (!required || (!!v && v.length > 0) || !!readOnly) || `Este campo es requerido.`
        },
    },

    file: {
        required: (required, readOnly) => {
            return v => (!required || !!v || !!readOnly) || `Este campo es requerido.`
        }
    }
}

export default procedureFormValidator
